<template>
  <v-dialog v-model="visible" max-width="400px">
    <v-card :loading="loading">
      <v-card-title>Cetak Agenda Pimpinan</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <datepicker
          v-model="dateRange"
          range
          placeholder="Pilih Tanggal Surat"
          :shortcuts="datePickerShortcut"
        />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="visible = false">Tutup</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="downloadReport"
          :disabled="loading"
        >
          Cetak
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import { getReportAgenda } from '@/services/agenda'
import { shortcut } from '@/utils/date-picker'

const currentYear = moment().format('YYYY')

const dateRange = [
  moment(`${currentYear}-01-01`, 'YYYY-MM-DD').toDate(),
  moment().toDate()
]

export default {
  data() {
    return {
      visible: false,
      loading: false,
      dateRange,
      datePickerShortcut: shortcut
    }
  },
  computed: {},
  methods: {
    show() {
      this.dateRange = [...dateRange]
      this.visible = true
    },
    async downloadReport() {
      this.loading = true
      try {
        const params = {
          from: moment(this.dateRange[0]).format('YYYY-MM-DD'),
          to: moment(this.dateRange[1]).format('YYYY-MM-DD')
        }
        await getReportAgenda(params)
        this.loading = false
        this.visible = false
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.mx-datepicker-range {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
